// extracted by mini-css-extract-plugin
export default {"reportDetails":"HeaderList_reportDetails__UVf6f","wrapper":"HeaderList_wrapper__jEzEI","label":"HeaderList_label__eSFf0","value":"HeaderList_value__Uublb"};